import React, { FC } from 'react';
import styled from 'styled-components';
import { Layout, Avatar } from 'antd';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
} from '@ant-design/icons';
import { getUserData } from '../../utils/utilsFunctions';

const { Header } = Layout;
// const { Search } = Input

const HeaderX = styled(Header)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 1rem;
`

const MenuUnfoldOutlinedX = styled(MenuUnfoldOutlined)`
    font-size: 2rem;
`
const MenuFoldOutlinedX = styled(MenuFoldOutlined)`
    font-size: 2rem;
`
// const SearchX = styled(Search)`
//     width: 50%;
// `

interface SProps {
    collapsed?: any;
    toggle?: any;
}

const AdminHeader: FC<SProps> = ({ collapsed, toggle }) => {

    const user = JSON.parse(getUserData('user'));

    return (
        <>
            <HeaderX>
                {collapsed ? <MenuUnfoldOutlinedX onClick={toggle} /> : <MenuFoldOutlinedX onClick={toggle} />}
                {/* <SearchX placeholder="Search" onSearch={onSearch} enterButton /> */}
                <Avatar
                    size={{ xs: 24, sm: 32, md: 40, lg:50 , xl: 50, xxl: 60 }}
                    style={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer' }}
                >
                    {
                        user?.firstName.charAt(0).toUpperCase()
                    }
                </Avatar>
            </HeaderX>
        </>
    )
}

export default AdminHeader;